import React from 'react';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { APPSTORE_URL } from '../../data/introFeatures';

const IntroHero = () => {
    return (
        <section className="intro-hero">
            <div className="intro-hero__bg" aria-hidden="true">
                <span className="intro-hero__blob intro-hero__blob--purple" />
                <span className="intro-hero__blob intro-hero__blob--pink" />
            </div>
            <div className="intro-hero__inner">
                <div className="intro-hero__copy">
                    <span className="intro-hero__badge">
                        <FeatherIcon icon="award" size="14" /> 카페24 공식 앱스토어 등록
                    </span>
                    <h1>
                        카페24 <span className="intro-hero__title-accent">리뷰 솔루션</span>, 온리플<br />
                        쌓아둔 리뷰가 매출이 되는 가장 빠른 길
                    </h1>
                    <p className="intro-hero__sub">
                        AI 인사이트, 자동 동기화, 다양한 위젯, 그리고 자연스러운 작성 유도까지 —<br />
                        리뷰 운영에 필요한 모든 것, 온리플 하나면 충분합니다.
                    </p>
                    <div className="intro-hero__cta">
                        <a href={APPSTORE_URL} target="_blank" rel="noopener noreferrer" className="intro-btn intro-btn--primary">
                            카페24 앱스토어에서 시작하기 <FeatherIcon icon="external-link" size="14" />
                        </a>
                        <Link to="/signUp" className="intro-btn intro-btn--ghost">
                            14일 무료로 체험해 보기 <FeatherIcon icon="arrow-right" size="14" />
                        </Link>
                    </div>
                    <div className="intro-hero__rating">
                        <div className="intro-hero__stars" aria-label="평점 4.5 / 5.0">
                            {[0, 1, 2, 3, 4].map(i => (
                                <FeatherIcon key={i} icon="star" size="14" className={i < 4 ? 'is-on' : 'is-half'} />
                            ))}
                        </div>
                        <span>4.5 · 카페24 앱스토어 평점</span>
                    </div>
                </div>
                <div className="intro-hero__visual" aria-hidden="true">
                    <div className="intro-hero__mock">
                        <div className="intro-hero__mock-head">
                            <span className="intro-hero__mock-dot" />
                            <span className="intro-hero__mock-dot" />
                            <span className="intro-hero__mock-dot" />
                            <span className="intro-hero__mock-title">상품 상세 — 리뷰</span>
                        </div>
                        <div className="intro-hero__mock-body">
                            <div className="intro-hero__mock-summary">
                                <span role="img" aria-label="반짝임">✨</span> AI가 142건의 리뷰를 들여다봤어요. 빠른 배송과 꼼꼼한 포장이 손꼽힙니다.
                            </div>
                            <div className="intro-hero__mock-chips">
                                <span>디자인이 좋아요</span>
                                <span>포장이 꼼꼼해요</span>
                                <span>아이가 좋아해요</span>
                                <span>재구매 의사</span>
                            </div>
                            <div className="intro-hero__mock-stars">
                                {[0, 1, 2, 3, 4].map(i => (
                                    <FeatherIcon key={i} icon="star" size="14" />
                                ))}
                                <span>4.8</span>
                            </div>
                            <div className="intro-hero__mock-line" style={{ width: '90%' }} />
                            <div className="intro-hero__mock-line" style={{ width: '70%' }} />
                            <div className="intro-hero__mock-line" style={{ width: '80%' }} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default IntroHero;
